import { StudentNoteNoteType } from "../../../Utilities";
import { SharingRecordCustomFormValues } from "../SharingRecord";
import { StudentAcademicNoteFormValues } from "../StudentAcademicNote";
import { StudentAttendanceNoteFormValues } from "../StudentAttendanceNote";
import { StudentBehaviorNoteFormValues } from "../StudentBehaviorNote";
import { StudentHealthNoteFormValues } from "../StudentHealthNote";
import { StudentIncidentNoteFormValues } from "../StudentIncidentNote";
import { StudentInjuryNoteFormValues } from "../StudentInjuryNote";
import { StudentMedicationNoteFormValues } from "../StudentMedicationNote";
import { StudentSocialEmotionalNoteFormValues } from "../StudentSocialEmotionalNote";
import { Create, initialCreate } from "./form-values";

export const initialAcademicCreate: Create = {
	...initialCreate,
	noteType: StudentNoteNoteType.Academic,
	studentAcademicNote: [StudentAcademicNoteFormValues.blankItemInStudentNote],
};

export const initialAttendanceCreate: Create = {
	...initialCreate,
	noteType: StudentNoteNoteType.Attendance,
	sharingRecord: [{ ...SharingRecordCustomFormValues.blankItemInParent, isPublic: true }],
	studentAttendanceNote: [StudentAttendanceNoteFormValues.blankItemInStudentNote],
};

export const initialBehaviorCreate: Create = {
	...initialCreate,
	noteType: StudentNoteNoteType.Behavior,
	studentBehaviorNote: [StudentBehaviorNoteFormValues.blankItemInStudentNote],
};

export const initialGeneralCreate: Create = {
	...initialCreate,
	noteType: StudentNoteNoteType.General,
};

export const initialHealthCreate: Create = {
	...initialCreate,
	noteType: StudentNoteNoteType.Health,
	studentHealthNote: [StudentHealthNoteFormValues.blankItemInStudentNote],
};

export const initialIncidentCreate: Create = {
	...initialCreate,
	noteType: StudentNoteNoteType.Incident,
	studentIncidentNote: [StudentIncidentNoteFormValues.blankItemInStudentNote],
};

export const initialInjuryCreate: Create = {
	...initialCreate,
	noteType: StudentNoteNoteType.Injury,
	studentInjuryNote: [StudentInjuryNoteFormValues.blankItemInStudentNote],
};

export const initialMedicationCreate: Create = {
	...initialCreate,
	noteType: StudentNoteNoteType.Medication,
	studentMedicationNote: [StudentMedicationNoteFormValues.blankItemInStudentNote],
};

export const initialSocialEmotionalCreate: Create = {
	...initialCreate,
	noteType: StudentNoteNoteType.SocialEmotional,
	studentSocialEmotionalNote: [StudentSocialEmotionalNoteFormValues.blankItemInStudentNote],
};
